interface LoaderProps {
  color?: string;
}
export const Loader = ({ color = "#2d32aa" }: LoaderProps) => {
  return (
    <div
      className="spinner-border "
      role="status"
      style={{ color: color }}
    ></div>
  );
};

export default Loader;
